import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  return <Transition appear show={isOpen} as={Fragment} data-id="element-305">
      <Dialog as="div" className="relative z-50" onClose={onClose} data-id="element-306">
        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0" data-id="element-307">
          <div className="fixed inset-0 bg-black/25 backdrop-blur-sm" data-id="element-308" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto" data-id="element-309">
          <div className="flex min-h-full items-center justify-center p-4 text-center" data-id="element-310">
            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95" data-id="element-311">
              <Dialog.Panel className="w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all" data-id="element-312">
                <div className="flex items-center justify-between mb-5" data-id="element-313">
                  <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900" data-id="element-314">
                    {title}
                  </Dialog.Title>
                  <button onClick={onClose} className="rounded-full p-1 hover:bg-gray-100 transition-colors" data-id="element-315">
                    <X className="h-5 w-5 text-gray-500" data-id="element-316" />
                  </button>
                </div>
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>;
}